import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../pages/admin/admin_assets/css/common.css';
import axios from 'axios';
import config from '../../../config/config.js';

function Subscribers() {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch Subscribers
  const fetchSubscribers = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${config.API_BASE_URL}/get_subscribers.php`);
      const data = response.data;

      if (data.success) {
        setSubscribers(data.subscribers);  // Updated key from `categories` to `subscribers`
      } else {
        toast.error(data.message || 'Failed to fetch subscribers.');
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error('An error occurred while fetching subscribers.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscribers();
  }, []);

  return (
    <>
      <div className="container-fluid category_form_sec">
        <div className="table-container px-0">
          {loading ? (
            <p>Loading subscribers...</p>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                {subscribers.length > 0 ? (
                  subscribers.map((subscriber, index) => {
                    const formattedDate = new Date(subscriber.created_at).toLocaleDateString(); // Format date
                    return (
                      <tr key={subscriber.id || index}>
                        <td>{subscriber.email}</td>
                        <td>{formattedDate}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="2">No subscribers available</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        <ToastContainer />
      </div>
    </>
  );
}

export default Subscribers;
